export default __webpack_public_path__ + "static/media/locationIcon.97648e48.svg";